<div class="error">
  <fa-icon icon="exclamation-triangle"></fa-icon>
  <ng-content></ng-content>
</div>
